module.exports = __webpack_public_path__ + "img/face_love_blue_with_violet_eyes.44979a2b.svg";